var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-diff-chunk"},[_c('div',{staticClass:"changes"},_vm._l((_vm.chunk.changes),function(change,index){return _c('FileDiffChange',{key:index,attrs:{"change":change}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }